const legalDocumentOptionTranslations = {
  en: {
    seller: "Seller", buyer: "Buyer", owner: "Owner", investor: "Investor",
    bank: "Bank", creditor: "Creditor", fund: "Fund", servicer: "Servicer",
    insolvency_practitioner: "Insolvency practitioner", introducer: "Introducer",
    co_broker: "Co-broker", lawyer: "Lawyer",
    authorised_signatory: "Authorised signatory", other: "Other",
    nda: "Non-disclosure agreement (NDA)",
    ncnd: "Non-circumvention and non-disclosure agreement (NCND)",
    mou: "Memorandum of understanding (MOU)",
    loi: "Letter of intent (LOI)",
    introducer_agreement: "Introducer agreement",
    co_broker_agreement: "Co-broker agreement",
    seller_mandate: "Seller mandate",
    buyer_mandate: "Buyer mandate",
    commission_agreement: "Commission agreement",
    fee_protection_agreement: "Fee protection agreement",
    property_mediation_contract: "Property mediation contract",
    opportunity_acknowledgement: "Opportunity acknowledgement",
    draft: "Draft", pending_legal_review: "Pending legal review",
    changes_required: "Changes required", approved: "Approved",
    sent: "Sent for signature", partially_signed: "Partially signed",
    signed: "Signed", superseded: "Superseded", void: "Void",
    not_reviewed: "Not reviewed", pending: "Pending", rejected: "Rejected",
    portuguese_law_portuguese_courts: "Portuguese law and Portuguese courts",
    portuguese_law_icc_arbitration: "Portuguese law and ICC arbitration",
    icc_mediation_then_arbitration: "ICC mediation followed by arbitration",
    custom_lawyer_approval_required: "Custom framework — lawyer approval required",
    portuguese_courts: "Portuguese courts", negotiation: "Negotiation",
    mediation: "Mediation", icc_mediation: "ICC mediation",
    icc_arbitration: "ICC arbitration", custom: "Custom",
    panatlantik_draft: "Panatlantik controlled draft",
    licensed_third_party: "Licensed third-party template",
    client_supplied: "Client-supplied template",
    wet_ink: "Wet-ink signature",
    electronic: "Electronic signature",
    qualified_electronic: "Qualified electronic signature",
    mixed: "Mixed signature method",
  },
  pt: {
    seller: "Vendedor", buyer: "Comprador", owner: "Proprietário", investor: "Investidor",
    bank: "Banco", creditor: "Credor", fund: "Fundo", servicer: "Gestor de créditos",
    insolvency_practitioner: "Administrador de insolvência", introducer: "Apresentador",
    co_broker: "Mediador parceiro", lawyer: "Advogado",
    authorised_signatory: "Signatário autorizado", other: "Outro",
    nda: "Acordo de confidencialidade (NDA)",
    ncnd: "Acordo de não-circunvenção e confidencialidade (NCND)",
    mou: "Memorando de entendimento (MOU)",
    loi: "Carta de intenções (LOI)",
    introducer_agreement: "Acordo de apresentação",
    co_broker_agreement: "Acordo de mediação em parceria",
    seller_mandate: "Mandato do vendedor",
    buyer_mandate: "Mandato do comprador",
    commission_agreement: "Acordo de comissão",
    fee_protection_agreement: "Acordo de proteção de honorários",
    property_mediation_contract: "Contrato de mediação imobiliária",
    opportunity_acknowledgement: "Reconhecimento da oportunidade",
    draft: "Minuta", pending_legal_review: "A aguardar revisão jurídica",
    changes_required: "Alterações necessárias", approved: "Aprovado",
    sent: "Enviado para assinatura", partially_signed: "Parcialmente assinado",
    signed: "Assinado", superseded: "Substituído", void: "Sem efeito",
    not_reviewed: "Não revisto", pending: "Pendente", rejected: "Rejeitado",
    portuguese_law_portuguese_courts: "Lei portuguesa e tribunais portugueses",
    portuguese_law_icc_arbitration: "Lei portuguesa e arbitragem ICC",
    icc_mediation_then_arbitration: "Mediação ICC seguida de arbitragem",
    custom_lawyer_approval_required: "Enquadramento personalizado — aprovação jurídica obrigatória",
    portuguese_courts: "Tribunais portugueses", negotiation: "Negociação",
    mediation: "Mediação", icc_mediation: "Mediação ICC",
    icc_arbitration: "Arbitragem ICC", custom: "Personalizado",
    panatlantik_draft: "Minuta controlada Panatlantik",
    licensed_third_party: "Modelo licenciado de terceiro",
    client_supplied: "Modelo fornecido pelo cliente",
    wet_ink: "Assinatura manuscrita",
    electronic: "Assinatura eletrónica",
    qualified_electronic: "Assinatura eletrónica qualificada",
    mixed: "Método de assinatura misto",
  },
  zh: {
    seller: "卖方", buyer: "买方", owner: "所有人", investor: "投资者",
    bank: "银行", creditor: "债权人", fund: "基金", servicer: "资产服务机构",
    insolvency_practitioner: "破产管理人", introducer: "介绍人",
    co_broker: "合作经纪人", lawyer: "律师",
    authorised_signatory: "授权签字人", other: "其他",
    nda: "保密协议（NDA）",
    ncnd: "不规避与保密协议（NCND）",
    mou: "谅解备忘录（MOU）",
    loi: "意向书（LOI）",
    introducer_agreement: "介绍人协议",
    co_broker_agreement: "合作经纪协议",
    seller_mandate: "卖方委托书",
    buyer_mandate: "买方委托书",
    commission_agreement: "佣金协议",
    fee_protection_agreement: "费用保护协议",
    property_mediation_contract: "房地产中介合同",
    opportunity_acknowledgement: "投资机会确认书",
    draft: "草案", pending_legal_review: "等待法律审查",
    changes_required: "需要修改", approved: "已批准",
    sent: "已发送签署", partially_signed: "部分签署",
    signed: "已签署", superseded: "已被取代", void: "无效",
    not_reviewed: "未审查", pending: "待处理", rejected: "已拒绝",
    portuguese_law_portuguese_courts: "葡萄牙法律及葡萄牙法院",
    portuguese_law_icc_arbitration: "葡萄牙法律及ICC仲裁",
    icc_mediation_then_arbitration: "先进行ICC调解，后进行仲裁",
    custom_lawyer_approval_required: "自定义法律框架——须经律师批准",
    portuguese_courts: "葡萄牙法院", negotiation: "协商",
    mediation: "调解", icc_mediation: "ICC调解",
    icc_arbitration: "ICC仲裁", custom: "自定义",
    panatlantik_draft: "Panatlantik 受控草案",
    licensed_third_party: "经许可的第三方模板",
    client_supplied: "客户提供的模板",
    wet_ink: "手写签名",
    electronic: "电子签名",
    qualified_electronic: "合格电子签名",
    mixed: "混合签署方式",
  },
  fr: {
    seller: "Vendeur", buyer: "Acheteur", owner: "Propriétaire", investor: "Investisseur",
    bank: "Banque", creditor: "Créancier", fund: "Fonds", servicer: "Gestionnaire d’actifs",
    insolvency_practitioner: "Administrateur judiciaire", introducer: "Apporteur d’affaires",
    co_broker: "Co-intermédiaire", lawyer: "Avocat",
    authorised_signatory: "Signataire autorisé", other: "Autre",
    nda: "Accord de confidentialité (NDA)",
    ncnd: "Accord de non-contournement et de confidentialité (NCND)",
    mou: "Protocole d’accord (MOU)",
    loi: "Lettre d’intention (LOI)",
    introducer_agreement: "Contrat d’apporteur d’affaires",
    co_broker_agreement: "Accord de co-intermédiation",
    seller_mandate: "Mandat vendeur",
    buyer_mandate: "Mandat acheteur",
    commission_agreement: "Accord de commission",
    fee_protection_agreement: "Accord de protection des honoraires",
    property_mediation_contract: "Contrat de médiation immobilière",
    opportunity_acknowledgement: "Reconnaissance de l’opportunité",
    draft: "Projet", pending_legal_review: "En attente de révision juridique",
    changes_required: "Modifications requises", approved: "Approuvé",
    sent: "Envoyé pour signature", partially_signed: "Partiellement signé",
    signed: "Signé", superseded: "Remplacé", void: "Sans effet",
    not_reviewed: "Non révisé", pending: "En attente", rejected: "Rejeté",
    portuguese_law_portuguese_courts: "Droit portugais et tribunaux portugais",
    portuguese_law_icc_arbitration: "Droit portugais et arbitrage ICC",
    icc_mediation_then_arbitration: "Médiation ICC suivie d’un arbitrage",
    custom_lawyer_approval_required: "Cadre personnalisé — approbation juridique requise",
    portuguese_courts: "Tribunaux portugais", negotiation: "Négociation",
    mediation: "Médiation", icc_mediation: "Médiation ICC",
    icc_arbitration: "Arbitrage ICC", custom: "Personnalisé",
    panatlantik_draft: "Projet contrôlé Panatlantik",
    licensed_third_party: "Modèle tiers sous licence",
    client_supplied: "Modèle fourni par le client",
    wet_ink: "Signature manuscrite",
    electronic: "Signature électronique",
    qualified_electronic: "Signature électronique qualifiée",
    mixed: "Mode de signature mixte",
  },
  es: {
    seller: "Vendedor", buyer: "Comprador", owner: "Propietario",
    investor: "Inversor", bank: "Banco", creditor: "Acreedor",
    fund: "Fondo", servicer: "Gestor de activos",
    insolvency_practitioner: "Administrador concursal",
    introducer: "Introductor", co_broker: "Agente colaborador",
    lawyer: "Abogado", authorised_signatory: "Firmante autorizado",
    other: "Otro",
    nda: "Acuerdo de confidencialidad",
    ncnd: "Acuerdo de confidencialidad y no elusión",
    mou: "Memorando de entendimiento",
    loi: "Carta de intención",
    introducer_agreement: "Acuerdo de introducción",
    co_broker_agreement: "Acuerdo de colaboración entre agentes",
    seller_mandate: "Mandato del vendedor",
    buyer_mandate: "Mandato del comprador",
    commission_agreement: "Acuerdo de comisión",
    fee_protection_agreement: "Acuerdo de protección de honorarios",
    property_mediation_contract: "Contrato de mediación inmobiliaria",
    opportunity_acknowledgement: "Reconocimiento de oportunidad",
    draft: "Borrador", pending_legal_review: "Pendiente de revisión jurídica",
    changes_required: "Cambios requeridos", approved: "Aprobado",
    sent: "Enviado para firma", partially_signed: "Parcialmente firmado",
    signed: "Firmado", superseded: "Sustituido", void: "Anulado",
    not_reviewed: "No revisado", pending: "Pendiente", rejected: "Rechazado",
    portuguese_law_portuguese_courts: "Derecho portugués y tribunales portugueses",
    portuguese_law_icc_arbitration: "Derecho portugués y arbitraje ICC",
    icc_mediation_then_arbitration: "Mediación ICC seguida de arbitraje",
    custom_lawyer_approval_required: "Marco personalizado — requiere aprobación jurídica",
    portuguese_courts: "Tribunales portugueses", negotiation: "Negociación",
    mediation: "Mediación", icc_mediation: "Mediación ICC",
    icc_arbitration: "Arbitraje ICC", custom: "Personalizado",
    panatlantik_draft: "Borrador controlado Panatlantik",
    licensed_third_party: "Plantilla de tercero con licencia",
    client_supplied: "Plantilla proporcionada por el cliente",
    wet_ink: "Firma manuscrita",
    electronic: "Firma electrónica",
    qualified_electronic: "Firma electrónica cualificada",
    mixed: "Método de firma mixto",
  },
  de: {
    seller: "Verkäufer", buyer: "Käufer", owner: "Eigentümer",
    investor: "Investor", bank: "Bank", creditor: "Gläubiger",
    fund: "Fonds", servicer: "Forderungs- und Vermögensverwalter",
    insolvency_practitioner: "Insolvenzverwalter",
    introducer: "Vermittler", co_broker: "Kooperationsmakler",
    lawyer: "Rechtsanwalt", authorised_signatory: "Zeichnungsberechtigter",
    other: "Sonstige",
    nda: "Geheimhaltungsvereinbarung",
    ncnd: "Vertraulichkeits- und Nichtumgehungsvereinbarung",
    mou: "Absichtserklärung",
    loi: "Letter of Intent",
    introducer_agreement: "Vermittlungsvereinbarung",
    co_broker_agreement: "Kooperationsmaklervereinbarung",
    seller_mandate: "Verkäufermandat",
    buyer_mandate: "Käufermandat",
    commission_agreement: "Provisionsvereinbarung",
    fee_protection_agreement: "Honorar-Schutzvereinbarung",
    property_mediation_contract: "Immobilienvermittlungsvertrag",
    opportunity_acknowledgement: "Bestätigung der Geschäftsmöglichkeit",
    draft: "Entwurf", pending_legal_review: "Rechtliche Prüfung ausstehend",
    changes_required: "Änderungen erforderlich", approved: "Genehmigt",
    sent: "Zur Unterzeichnung gesendet", partially_signed: "Teilweise unterzeichnet",
    signed: "Unterzeichnet", superseded: "Ersetzt", void: "Ungültig",
    not_reviewed: "Nicht geprüft", pending: "Ausstehend", rejected: "Abgelehnt",
    portuguese_law_portuguese_courts: "Portugiesisches Recht und portugiesische Gerichte",
    portuguese_law_icc_arbitration: "Portugiesisches Recht und ICC-Schiedsverfahren",
    icc_mediation_then_arbitration: "ICC-Mediation mit anschließendem Schiedsverfahren",
    custom_lawyer_approval_required: "Individueller Rahmen — rechtliche Genehmigung erforderlich",
    portuguese_courts: "Portugiesische Gerichte", negotiation: "Verhandlung",
    mediation: "Mediation", icc_mediation: "ICC-Mediation",
    icc_arbitration: "ICC-Schiedsverfahren", custom: "Individuell",
    panatlantik_draft: "Kontrollierter Panatlantik-Entwurf",
    licensed_third_party: "Lizenzierte Drittanbietervorlage",
    client_supplied: "Vom Kunden bereitgestellte Vorlage",
    wet_ink: "Handschriftliche Unterschrift",
    electronic: "Elektronische Signatur",
    qualified_electronic: "Qualifizierte elektronische Signatur",
    mixed: "Gemischtes Signaturverfahren",
  },
  it: {
    seller: "Venditore", buyer: "Acquirente", owner: "Proprietario",
    investor: "Investitore", bank: "Banca", creditor: "Creditore",
    fund: "Fondo", servicer: "Gestore di crediti e attivi",
    insolvency_practitioner: "Curatore fallimentare",
    introducer: "Segnalatore", co_broker: "Mediatore collaboratore",
    lawyer: "Avvocato", authorised_signatory: "Firmatario autorizzato",
    other: "Altro",
    nda: "Accordo di riservatezza",
    ncnd: "Accordo di riservatezza e non elusione",
    mou: "Protocollo d’intesa",
    loi: "Lettera d’intenti",
    introducer_agreement: "Accordo di segnalazione",
    co_broker_agreement: "Accordo di collaborazione tra mediatori",
    seller_mandate: "Mandato del venditore",
    buyer_mandate: "Mandato dell’acquirente",
    commission_agreement: "Accordo sulle commissioni",
    fee_protection_agreement: "Accordo di protezione degli onorari",
    property_mediation_contract: "Contratto di mediazione immobiliare",
    opportunity_acknowledgement: "Riconoscimento dell’opportunità",
    draft: "Bozza", pending_legal_review: "In attesa di revisione legale",
    changes_required: "Modifiche richieste", approved: "Approvato",
    sent: "Inviato per la firma", partially_signed: "Parzialmente firmato",
    signed: "Firmato", superseded: "Sostituito", void: "Annullato",
    not_reviewed: "Non revisionato", pending: "In sospeso", rejected: "Respinto",
    portuguese_law_portuguese_courts: "Diritto portoghese e tribunali portoghesi",
    portuguese_law_icc_arbitration: "Diritto portoghese e arbitrato ICC",
    icc_mediation_then_arbitration: "Mediazione ICC seguita da arbitrato",
    custom_lawyer_approval_required: "Quadro personalizzato — approvazione legale richiesta",
    portuguese_courts: "Tribunali portoghesi", negotiation: "Negoziazione",
    mediation: "Mediazione", icc_mediation: "Mediazione ICC",
    icc_arbitration: "Arbitrato ICC", custom: "Personalizzato",
    panatlantik_draft: "Bozza controllata Panatlantik",
    licensed_third_party: "Modello di terzi con licenza",
    client_supplied: "Modello fornito dal cliente",
    wet_ink: "Firma autografa",
    electronic: "Firma elettronica",
    qualified_electronic: "Firma elettronica qualificata",
    mixed: "Metodo di firma misto",
  },
  ru: {
    seller: "Продавец", buyer: "Покупатель", owner: "Собственник",
    investor: "Инвестор", bank: "Банк", creditor: "Кредитор",
    fund: "Фонд", servicer: "Управляющий активами",
    insolvency_practitioner: "Арбитражный управляющий",
    introducer: "Посредник", co_broker: "Партнёрский брокер",
    lawyer: "Юрист", authorised_signatory: "Уполномоченный подписант",
    other: "Другое",
    nda: "Соглашение о конфиденциальности",
    ncnd: "Соглашение о конфиденциальности и необходе",
    mou: "Меморандум о взаимопонимании",
    loi: "Письмо о намерениях",
    introducer_agreement: "Посредническое соглашение",
    co_broker_agreement: "Соглашение о сотрудничестве брокеров",
    seller_mandate: "Мандат продавца",
    buyer_mandate: "Мандат покупателя",
    commission_agreement: "Соглашение о комиссии",
    fee_protection_agreement: "Соглашение о защите вознаграждения",
    property_mediation_contract: "Договор посредничества в сфере недвижимости",
    opportunity_acknowledgement: "Подтверждение инвестиционной возможности",
    draft: "Черновик", pending_legal_review: "Ожидает юридической проверки",
    changes_required: "Требуются изменения", approved: "Одобрено",
    sent: "Отправлено на подписание", partially_signed: "Частично подписано",
    signed: "Подписано", superseded: "Заменено", void: "Аннулировано",
    not_reviewed: "Не проверено", pending: "Ожидает", rejected: "Отклонено",
    portuguese_law_portuguese_courts: "Португальское право и суды Португалии",
    portuguese_law_icc_arbitration: "Португальское право и арбитраж ICC",
    icc_mediation_then_arbitration: "Медиация ICC с последующим арбитражем",
    custom_lawyer_approval_required: "Индивидуальная правовая схема — требуется одобрение юриста",
    portuguese_courts: "Суды Португалии", negotiation: "Переговоры",
    mediation: "Медиация", icc_mediation: "Медиация ICC",
    icc_arbitration: "Арбитраж ICC", custom: "Индивидуальный",
    panatlantik_draft: "Контролируемый проект Panatlantik",
    licensed_third_party: "Лицензированный сторонний шаблон",
    client_supplied: "Шаблон, предоставленный клиентом",
    wet_ink: "Собственноручная подпись",
    electronic: "Электронная подпись",
    qualified_electronic: "Квалифицированная электронная подпись",
    mixed: "Смешанный способ подписания",
  },
};

export default legalDocumentOptionTranslations;
